/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/StatusType/Form
 * @desc Filter Metadata form
 */

import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { ParamsStateContextProvider } from 'labstep-web/contexts/params-state';
import { Flex } from 'labstep-web/core/Flex';
import { Select as ReactSelect } from 'labstep-web/core/Select';
import { SearchSelectContainer as SearchSelect } from 'labstep-web/core/Select/Search';
import { useHasFeatureFlagEnabled } from 'labstep-web/hooks/feature-flag';
import { EntityState } from 'labstep-web/models/entity-state.model';
import {
  ExperimentWorkflowStatusKeys,
  ExperimentWorkflowStatusTypeValues,
} from 'labstep-web/models/experiment-workflow.model';
import { LocationService } from 'labstep-web/services/location.service';
import {
  PostFilterStatusTypeCompleted,
  PostFilterStatusTypeStarted,
  PostFilterStatusTypeUnstarted,
} from 'labstep-web/services/postFilter/filters/statusType';
import type React from 'react';
import { withRouter } from 'react-router-dom';
import type { IFilterStatusTypeFormProps } from './types';

const FilterStatusTypeForm: React.FC<IFilterStatusTypeFormProps> = ({
  addPostFilter,
  onDone,
  activeGroup,
  history,
  location,
}) => {
  const hasSignatureFeatureEnabled = useHasFeatureFlagEnabled(
    'signature_workflow',
  );

  return (
    <Flex column spacing="gap">
      <ReactSelect
        placeholder={
          hasSignatureFeatureEnabled
            ? 'Select status type'
            : 'Select status'
        }
        options={Object.keys(ExperimentWorkflowStatusTypeValues).map(
          (key) => ({
            label:
              ExperimentWorkflowStatusTypeValues[
                key as keyof typeof ExperimentWorkflowStatusTypeValues
              ],
            value: key,
          }),
        )}
        isClearable
        onChange={(selectedOption: Record<string, unknown>) => {
          const { value } = selectedOption;
          LocationService.removeQueryParameter(
            history,
            location,
            'entity_state_name',
          );
          if (value === ExperimentWorkflowStatusKeys.unstarted) {
            addPostFilter(
              PostFilterStatusTypeUnstarted.getNode(),
              true,
            );
          }
          if (value === ExperimentWorkflowStatusKeys.started) {
            addPostFilter(
              PostFilterStatusTypeStarted.getNode(),
              true,
            );
          }
          if (value === ExperimentWorkflowStatusKeys.completed) {
            addPostFilter(
              PostFilterStatusTypeCompleted.getNode(),
              true,
            );
          }
          onDone();
        }}
      />
      {hasSignatureFeatureEnabled && (
        <>
          OR
          <ParamsStateContextProvider value={{}}>
            <SearchSelect
              isCursor
              entityName={EntityState.entityName}
              params={{
                group_id: activeGroup?.id,
                group_by_name: 1,
                sort: 'name',
              }}
              onChange={(selectedOption) => {
                if (selectedOption) {
                  LocationService.addQueryParameter(
                    history,
                    location,
                    'entity_state_name',
                    selectedOption.name,
                  );
                  onDone();
                }
              }}
              value={null}
              placeholder="Select a specific status"
            />
          </ParamsStateContextProvider>
        </>
      )}
    </Flex>
  );
};

export default withRouter(withActiveGroup(FilterStatusTypeForm));
